<template>
    <div
        v-if="
            Boolean(
                text ||
                    linkRutube ||
                    autoplayVideo ||
                    image ||
                    galleryImages.length
            )
        "
        class="space-y-5 md:space-y-10">
        <AtomTitle v-if="title">
            {{ title }}
        </AtomTitle>

        <div
            :class="{
                'lg:flex-row-reverse': rowReverse,
            }"
            class="flex gap-10 max-lg:flex-col">
            <div
                v-if="text"
                v-html="text"
                :class="
                    ['text + image', 'text + video'].includes(blockType)
                        ? 'md:basis-1/2'
                        : 'md:basis-3/4'
                "
                class="tinyeditor shrink-0 space-y-4 text-16/148 font-medium text-accent-100" />

            <div
                v-if="image && ['text + image', 'image'].includes(blockType)"
                class="w-full overflow-hidden rounded-12 object-contain">
                <picture>
                    <source
                        v-if="image.webp_url"
                        type="image/webp"
                        :srcset="getMediaLink(image.webp_url || '') || ''" />

                    <source
                        v-else-if="!image.webp_url && !image.url"
                        type="image/webp"
                        srcset="
                            /assets/images/ui/placeholder/webp/cromi.webp
                        " />

                    <img
                        :width="image.width || 416"
                        :height="image.height || 234"
                        :alt="image.alt || title || image.type"
                        :src="
                            getMediaLink(image.url || '') ||
                            '/assets/images/ui/placeholder/jpg-png/cromi.png'
                        "
                        class="w-full rounded-12 object-contain" />
                </picture>
            </div>
            <div
                v-else-if="linkRutube"
                class="w-full">
                <BlockVideo
                    :size="blockType === 'video' ? 'big' : 'medium'"
                    :url="linkRutube"
                    :title="title"
                    :preview="previewRutube" />
            </div>
            <div
                v-else-if="autoplayVideo"
                class="w-full">
                <BlockAutoplayVideo :autoplay-video />
            </div>
            <div
                v-else-if="galleryImages.length"
                class="w-full">
                <BlockGallery
                    :images="galleryImages"
                    :slider-name="blockId" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Image, Video } from '~/types/global.types'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BlockAutoplayVideo from '~/components/particles/block-card/BlockAutoplayVideo.vue'
import BlockGallery from '~/components/particles/block-card/BlockGallery.vue'
import BlockVideo from '~/components/particles/block-card/BlockVideo.vue'
import type { TBlockType } from '~/components/particles/block-card/block-card.types'

defineProps({
    blockId: {
        type: Number as PropType<number>,
        required: true,
    },
    blockType: {
        type: String as PropType<TBlockType>,
        required: true,
    },
    rowReverse: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    title: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    text: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    image: {
        type: [Object, null] as PropType<Image | null>,
        default: null,
    },
    autoplayVideo: {
        type: [Object, null] as PropType<Video | null>,
        default: null,
    },
    linkRutube: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    previewRutube: {
        type: [Object, null] as PropType<Image | null>,
        default: null,
    },
    galleryImages: {
        type: Array as PropType<Image[]>,
        default: () => [],
    },
})
</script>
